import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { RouterModule } from "@angular/router";

import { FinancialInvestmentListV2Component } from "./components/financial-investment-list/financial-investment-list.components";
import { FinancialInvestmentDetailComponent } from "./components/financial-investment-detail/financial-investment-detail.component";
import { FinancialInvestmentFormDialogComponent } from "./components/financial-investment-form-dialog/financial-investment-form-dialog.component";
import { FinancialInvestmentPayDialogComponent } from "./components/financial-investment-pay-dialog/financial-investment-pay-dialog.component";
import { SharedModule } from "../../shared/shared.module";
import { SharedModule as AppSharedModule } from "../../../shared/shared.module";

@NgModule({
  declarations: [
    FinancialInvestmentListV2Component,
    FinancialInvestmentDetailComponent,
    FinancialInvestmentFormDialogComponent,
    FinancialInvestmentPayDialogComponent,
  ],
  exports: [
    FinancialInvestmentListV2Component
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    RouterModule,
    FormsModule,
    SharedModule,
    AppSharedModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatSlideToggleModule,
  ],
})

export class FinancialInvestmentModule { }
